import React, {useContext,useState} from 'react';
import {
  BrowserRouter as Router,
  MemoryRouter,
  Switch,
  Route,
  Redirect} from "react-router-dom";
import './App.scss';
import {AuthenticationContext} from './components/AuthenticationContextProvider';
import NavigationBar from './components/NavigationBar/NavigationBar';
import Library from './components/Library/Library';
import Favorites from './components/Favorites/Favorites';
import HomePage from './components/HomePage/HomePage';
import {ConfigContext} from './components/ConfigContextProvider';

function App({rootUrl}) {
  const {navigation} = useContext(AuthenticationContext);
  const {ASSETS_URL} = useContext(ConfigContext);
  let currentType = "";
  let currentCategory="";

  const getBaseName = () => {
    if (rootUrl) return rootUrl;
    const firstPath = window.location.pathname.split('/')[1];
    return window.LIBRARY_ROOT_URL || ((firstPath.length===2) ? "/"+firstPath+"/samples/" : process.env.PUBLIC_URL);
  }

  const layout= (type, category, order) => {
    currentType = type;
    currentCategory = category
    return (
      <>
        <NavigationBar items={navigation.items}  type={type} category={category} order={order}  />
        <Library type={type} category={category} order={order}/>
      </>
    )
  }

  const routes = navigation && (
    <Switch>
      <Route exact path={`/`}>
        <Redirect to={`/${navigation.items[0].url}`} />
      </Route>
      <Route exact path="/favorites">
        <div className="AppSampleContent__favorites" style={{backgroundImage: `url("${ASSETS_URL}/favorites.jpg") ` }}>
          <NavigationBar items={navigation.items} back={true}  />
          <Favorites type={currentType} category={currentCategory} />
        </div>
      </Route>
      {navigation.items.map((item, i) => {
        return (
          <Route key={`route_${i}`} path={`/${item.url}`}>
            <Switch>
              {(item.order && item.order.map((order, k) => {
                return (
                  <Route exact key={`route_${i}_order_${k}`} path={`/${item.url}/${order.url}`}>
                    {layout(item, null, order)}
                  </Route>
                )
                }))}
                {item.category && item.category.length >0 ?
                  <Route exact  path={`/${item.url}`}>
                    <Redirect to={`/${item.url}/${item.category[0].url}`} />
                  </Route> :
                  <Route exact  path={`/${item.url}`}>
                    {layout(item)}
                  </Route>
                }
              </Switch>
            <Switch>
              {(item.category && item.category.map((category, k) => {
                  return (
                    <Route  key={`route_cat_${i}_order_${k}`} path={`/${item.url}/${category.url}`}>
                      {category.order && category.order.length >0 ?
                        <Route exact path={`/${item.url}/${category.url}/`}>
                          <Redirect to={`/${item.url}/${category.url}/${category.order[0].url}`} />
                        </Route>
                      : <Route exact path={`/${item.url}/${category.url}/`}>
                          {layout(item, category, null)}
                        </Route>  }
                      <Switch>
                        {(category.order && category.order.map((order, o) => {
                            return (
                              <Route exact key={`route_${i}_cat_${k}_order_${o}`} path={`/${item.url}/${category.url}/${order.url}`}>
                                {layout(item, category, order )}
                              </Route>
                            )
                          }
                          ))}
                      </Switch>
                    </Route>
                  )
                }
                ))}
            </Switch>
          </Route>
        )
      })}
    </Switch>
  );

  const noRequest = !!window.LIBRARY_NO_REQUEST;

  return (
    <div className={`App AppSample${noRequest ? ' AppSample--no-request' : ''}`}>
      {navigation && (
        window.LIBRARY_DISABLE_ROUTING
          ? <MemoryRouter initialEntries={[`/${navigation.items[0].url}`]}>{routes}</MemoryRouter>
          : <Router basename={getBaseName()}>{routes}</Router>
      )}
    </div>
  );
}

export default App;
